<!--suppress JSNonASCIINames -->
<template>
  <vx-card>
    <div>
      <div class="flex justify-between items-center">
        <p style="font-size: 18px; font-weight: 700">항만(방파제)</p>

        <FieldWriteButtonGroup
          :useCopy="isEditable && !!fieldId"
          :useDelete="isEditable && !!fieldId"
          :useSave="isEditable"
          @onClickCopy="onClickCopy"
          @onClickExcel="onClickDownloadExcel"
          @onClickDelete="onClickDelete"
          @onClickMoveList="onClickMoveList"
          @onClickSave="onClickSave"
        />
      </div>

      <!-- 기본정보 -->
      <div class="mt-28px">
        <h5 class="mb-4"><i class="dot"></i> 기본정보</h5>
        <div class="writeGridContainer">
          <div>
            <div>관리주체</div>
            <ml-input v-model="form.management_entity" :readonly="readonly" />
          </div>
          <div>
            <div>소유자</div>
            <ml-input v-model="form.owner" :readonly="readonly" />
          </div>
          <div>
            <div>전화번호</div>
            <ml-input v-model="form.phoneNumber" :readonly="readonly" placeholder="예) 055-123-4567" />
          </div>
          <div>
            <div>보관자</div>
            <ml-input v-model="form.custodian" :readonly="readonly" />
          </div>
          <div>
            <div>관리방법</div>
            <vs-select autocomplete v-model="form.관리방법">
              <vs-select-item text="직접관리" value="직접관리" />
              <vs-select-item text="위탁관리" value="위탁관리" />
            </vs-select>
          </div>
          <div>
            <div>소관부서</div>
            <ml-input v-model="form.소관부서" :readonly="readonly" />
          </div>
          <div>
            <div>담당팀</div>
            <ml-input v-model="form.담당팀" :readonly="readonly" />
          </div>
          <div>
            <div>담당주무관</div>
            <ml-input v-model="form.담당주무관" :readonly="readonly" />
          </div>
        </div>
      </div>
    </div>

    <!-- 시설물 정보 -->
    <port-write-body :form="form" :category-info="categoryInfo" :readonly="readonly" />

    <!-- 관리 부서 및 업체 등록 -->
    <company-add-module
      title="관리 부서 및 업체 등록"
      :tableColumns="[
        { head: '구분', key: 'com_type' },
        { head: '부서(업체)명', key: 'com_name' },
        { head: '연락처', key: 'phone' },
      ]"
      :isSimple="true"
      :readonly="readonly"
      v-model="companyList"
      @remove="removeCompany"
    />

    <!-- 전경사진 -->
    <photo-upload-grid-module :row-count="2" :grid-count="2" v-model="form.photoList" section-title="전경사진" placeholder="전경사진" :readonly="readonly" />

    <file-upload-module v-model="fileList" class="mt-28px" :readonly="readonly" target="field" />

    <FieldWriteButtonGroup
      :useCopy="isEditable && !!fieldId"
      :useDelete="isEditable && !!fieldId"
      :useSave="isEditable"
      @onClickCopy="onClickCopy"
      @onClickExcel="onClickDownloadExcel"
      @onClickDelete="onClickDelete"
      @onClickMoveList="onClickMoveList"
      @onClickSave="onClickSave"
    />
  </vx-card>
</template>

<script>
import FileUploadModule from "@/views/modules/FileUploadModule";
import CompanyAddModule from "@/views/_BS/components/CompanyAddModule";
import DateSelector from "@/components/selector/DateSelector";
import DateSelectorRang from "@/components/selector/DateSelectorRang";
import SignField from "@/components/SignField.vue";
import PhotoUploadGridModule from "@/views/modules/PhotoUploadGridModule";
import moment from "moment";
import PortWriteBody from "@/views/fields/single-page/port/PortWriteBody.vue";
import BridgeWriteBody from "@/views/fields/single-page/bridge/BridgeWriteBody.vue";
import ExcelJS from "exceljs";
import FieldWriteButtonGroup from "@/views/fields/components/FieldWriteButtonGroup.vue";

export default {
  components: {
    BridgeWriteBody,
    PortWriteBody,
    FileUploadModule,
    CompanyAddModule,
    DateSelector,
    DateSelectorRang,
    SignField,
    PhotoUploadGridModule,
    FieldWriteButtonGroup,
  },
  data() {
    return {
      form: {
        phoneNumber: "",
        custodian: "",
        관리방법: "직접관리",
        소관부서: "",
        담당팀: "",
        담당주무관: "",

        facilityNumber: "",
        managementNumber: "",
        facilityName: "",
        routeDivision: "",
        routeDetail: "",

        facility_category_id: "",

        cat1: "",
        cat2: "",
        cat3: "",
        classification: "",

        socEvaluationTarget: "",
        address: "",
        management_entity: "",
        management_type: "",
        owner: "",
        ownerType: "",
        businessPlanApprovalDate: "",
        completionDate: "",
        defectLiabilityExpirationDate1: "",
        detailedSpecifications: "",
        safetyInspectionAndDiagnosisHistory: "",
        repairAndReinforcementHistory: "",
        accessibleVentCover: "",
        designPeriod: "",
        designer: "",
        defectLiabilityExpirationDate2: "",
        constructionPeriod: "",
        contractor: "",
        totalConstructionCost: "",
        seismicDesignTarget: "",
        seismicDesignApplication: "",
        seismicDesignStandard: "",
        seismicPerformanceEvaluation: "",
        seismicReinforcement: "",
        young21Target: "",
        auditPeriod: "",
        auditor: "",
        projectOwner: "",
        constructionName: "",
        defectLiabilityExpirationDate: "",
        constructionSupervisor: "",
        creationDate: moment().format("YYYY-MM-DD"),
        author: this.$store.state.auth.userInfo ? this.$store.state.auth.userInfo.name : "",
        signature: "",
        lastModifiedDate: "",
        lastModifiedBy: "",
        remarks: "",

        // 상세제원(항만)
        종류: "",
        허용월파량: "",
        설계파_파고: "",
        설계파_파향: "",
        설계파_주기: "",
        수심_최대: "",
        수심_최소: "",
        조위_약최고고조위: "",
        조위_평균해면: "",

        DL_EL_표교차: "",
        DL_기준항만: "",
        형식분류_목적: "",
        형식분류_구조: "",
        마루높이: "",
        사면경사: "",
        주요구조물설계기준강도: "",

        방파제파제제_연장_제간부: "",
        방파제파제제_연장_제두부: "",
        방파제파제제_상치공폭_제간부: "",
        방파제파제제_상치공폭_제두부: "",
        호안_연장: "",
        호안_상치공_규격: "",
        호안_상치공_형상: "",
        기초처리공: "",

        피복제_제간부: "",
        피복제_제두부: "",
        제체_블록식: "",
        제체_케이슨식: "",
        제체_기타: "",

        배후지_매립고: "",
        배후지_이용조건: "",
        배후지_배수시설: "",
        간이접안시설_위치: "",
        간이접안시설_대상선박규모: "",
        간이접안시설_방충재: "",
        간이접안시설_계선주: "",
        팡로표지시설_형식: "",
        팡로표지시설_구조: "",

        otherSpecifications: "",

        companyList: [],
        photoList: [],
      },

      companyList: [],
      userList: [],
      joinUsers: [],
      fileList: [],
      categoryInfo: {
        facility_category_id: 0,
        cat1: "",
        cat2: "",
        cat3: "",
        classification: "",
      },

      catLock: true,
    };
  },
  computed: {
    projectId() {
      return Number(this.$route.params.proj_id);
    },
    fieldId() {
      return this.$route.params.fieldId;
    },
    myInfo() {
      return this.$store.state.auth.userInfo;
    },
    isAdmin() {
      let isAdmin = false;
      const myInfo = this.$store.state.auth.userInfo;
      isAdmin = isAdmin || parseInt(myInfo.is_superuser) > 0;
      return isAdmin;
    },
    /**
     * 현재 사용자가 프로젝트 관리자인지 확인합니다.
     * 프로젝트 관리자는 사업장을 등록/수정/삭제할 수 있습니다.
     * @returns {boolean}
     */
    isProjectManager() {
      const memberInfo = this.$store.state.member.memberInfo;
      if (memberInfo) {
        if (memberInfo.is_superuser) {
          return true;
        }

        const projects = memberInfo.projects;
        if (projects && projects.length > 0) {
          for (const project of projects) {
            if (`${project.id}` === `${this.projectId}`) {
              return project.pivot.is_manager;
            }
          }
        }
      }
      return false;
    },
    /**
     * 사업장을 프로젝트 관리자만 수정할 수 있는지 확인합니다.
     * @returns {boolean}
     */
    isFieldEditByManagerOnly() {
      const projectInfo = this.$store.state.project.projectInfo;

      if (projectInfo.field_edit_by_manager_only) {
        return true;
      }

      return false;
    },
    isEditable() {
      if (this.isFieldEditByManagerOnly) {
        return this.isProjectManager;
      }
      return true;
    },
    readonly() {
      return !this.isEditable;
    },
  },
  watch: {
    async companyList() {
      await this.initMembers();
    },
  },
  async created() {
    await this.$store.dispatch("member/LOAD_MEMBER_DETAIL");
    await this.$store.dispatch("project/LOAD_PROJECT", { project_id: this.projectId });
  },
  async mounted() {
    if (this.fieldId) {
      await this.loadField();
    } else {
      this.form.담당팀 = (this.$store.state.auth.userInfo && this.$store.state.auth.userInfo.section) || "";
    }
  },
  methods: {
    async loadField() {
      const fieldId = this.fieldId;
      await this.$store.dispatch("project/LOAD_FIELD", { fieldId });
      const info = this.$store.state.project.fieldInfo;

      this.joinUsers = info.users;
      this.form = { ...this.form, ...info, ...JSON.parse(info.meta) };

      if (info.facility_category) {
        this.form.facility_category_id = info.facility_category.id;
        this.form.cat1 = info.facility_category.cat1;
        this.form.cat2 = info.facility_category.cat2;
        this.form.cat3 = info.facility_category.cat3;
        this.form.classification = info.facility_category.classification;

        this.categoryInfo = {
          facility_category_id: info.facility_category.id,
          cat1: info.facility_category.cat1,
          cat2: info.facility_category.cat2,
          cat3: info.facility_category.cat3,
          classification: info.facility_category.classification,
        };
      }

      if (this.form.companies && info.companies.length > 0) {
        const companies = [];
        for (const company of info.companies) {
          companies.push(company);
        }
        this.companyList = companies;

        await this.initMembers();
      }

      // 첨부파일
      this.form.fileList = info.attachments || [];
      if (this.form.fileList) {
        this.fileList = this.form.fileList;
      }

      // this.form.photoList 항목이 2개보다 적을 경우, 빈 항목을 추가한다.
      if (this.form.photoList.length < 2) {
        for (let i = this.form.photoList.length; i < 2; i++) {
          this.form.photoList.push({ id: "", url: "" });
        }
      }
    },

    async initMembers() {
      const joinUsers = this.joinUsers;
      const members = [];
      for (const company of this.companyList) {
        members.push(...(await this.loadMember(company.id)));
      }

      for (const member of members) {
        let join_project = false;
        for (const user of joinUsers) {
          if (user.id === member.id) {
            join_project = true;
            break;
          }
        }
        member.join_project = join_project;
      }

      this.userList = members;
    },

    async loadMember(company_id) {
      const page = 1;
      const perPage = 100;
      await this.$store.dispatch("company/LOAD_MEMBER_LIST", { page, perPage, company_id });
      return JSON.parse(JSON.stringify(this.$store.state.company.memberList));
    },

    removeCompany(company) {
      let i = 0;
      for (i = 0; i < this.joinUsers.length; i++) {
        const usr = this.joinUsers[i];
        if (usr.company_id === company.id) {
          this.joinUsers.splice(i, 1);
          i--;
        }
      }
    },

    customAlert(msg, title) {
      const customAlert = new CustomEvent("customAlert", {
        detail: {
          title: title ? title : "오류가 발생했습니다",
          message: msg,
        },
      });
      window.dispatchEvent(customAlert);
    },

    onClickSave(isCopy) {
      // 필수 : facilityName,
      if (!this.form.facilityName) {
        this.customAlert("시설물명을 입력해주세요.");
        return;
      }
      if (this.form.phoneNumber && !/^[0-9+()\-\s]+$/.test(this.form.phoneNumber)) {
        this.customAlert("전화번호는 숫자와 하이픈(-)만 입력할 수 있습니다.");
        return;
      }

      const option = {
        project_id: this.projectId, // 프로젝트 ID
        field_name: this.form.facilityName, // 현장(시설물, 사업장) 이름
        contract_code: this.form.facilityNumber, // 계약번호
        address: this.form.address, // 주소
        phone: this.form.phoneNumber, // 대표번호
        be_completed_at: this.form.completionDate, // 준공일
        deposit_amount: this.form.totalConstructionCost, // 총공사비
        facility_category_id: this.form.facility_category_id, // Category
        uploads: this.fileList.map((file) => file.id), // 파일
      };

      const company_ids = [];
      for (const com of this.companyList) {
        company_ids.push(com.id);
      }
      option.company_ids = company_ids;

      if (this.fieldId) {
        const user_ids = [];
        if (this.joinUsers.length > 0) {
          for (const user of this.joinUsers) {
            user_ids.push(user.id);
          }
        }
        option.user_ids = user_ids;
      }
      if (isCopy) {
        option.meta = {
          ...this.form,
          creationDate: moment().format("YYYY-MM-DD"),
          author: this.myInfo.name,
          lastModifiedDate: moment().format("YYYY-MM-DD"),
          lastModifiedBy: this.myInfo.name,
        };
        this.$emit("copy", option);
      } else {
        // Meta
        option.meta = { ...this.form, lastModifiedDate: moment().format("YYYY-MM-DD"), lastModifiedBy: this.myInfo.name };
        this.$emit("save", option);
      }
    },
    onClickCopy() {
      this.onClickSave(true);
    },
    onClickDelete() {
      if (!this.fieldId) return;
      this.$emit("delete", this.fieldId);
    },
    onClickMoveList() {
      this.$emit("moveList");
    },
    async onClickDownloadExcel() {
      // 엑셀 파일 가져오기
      // 파일은 public/fms/ 경로에 저장되어 있다.
      const response = await fetch("/fms/시설물관리대장_항만.xlsx");
      const arrayBuffer = await response.arrayBuffer();

      const workbook = new ExcelJS.Workbook();
      await workbook.xlsx.load(arrayBuffer);

      // 첫번째 시트의 이름 가져오기
      const worksheet = workbook.worksheets[0];

      // 시트에 데이터 입력하기
      this.applyDataToSheet(worksheet);

      const buffer = await workbook.xlsx.writeBuffer();
      const blob = new Blob([buffer], { type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" });

      let fileName = "";
      if (this.form.facilityName) {
        if (this.form.facilityNumber) {
          fileName = `시설물관리대장_${this.form.facilityName}_${this.form.facilityNumber}`;
        } else {
          fileName = `시설물관리대장_${this.form.facilityName}`;
        }
      } else if (this.form.facilityNumber) {
        fileName = `시설물관리대장_${this.form.facilityNumber}`;
      } else {
        fileName = `시설물관리대장`;
      }
      fileName += ".xlsx";

      const url = window.URL.createObjectURL(blob);

      const a = document.createElement("a");
      a.href = url;
      a.download = fileName;
      document.body.appendChild(a);
      a.click();
      window.URL.revokeObjectURL(url);
    },
    applyDataToSheet(worksheet) {
      const cellMatchInfo = {
        facilityNumber: ["X4", "B20"], // 시설물번호
        managementNumber: ["X5", "K20"], // 관리번호
        facilityName: ["X6", "Q20", "B41"], // 시설물명
        management_entity: ["W13", "T22"], // 관리주체
        owner: ["W14"], // 소유자
        custodian: ["W15"], // 보관자
        routeDivision: ["AA20"], // 노선-구분
        routeDetail: ["AF20"], // 노선-세부노선
        cat1: ["AX20"], // 시설물구분
        cat3: ["AL20"], // 시설물종류
        classification: ["AR20"], // 시설물종별
        socEvaluationTarget: ["BE20"], // SOC성능평가대상
        address: ["B22"], // 주소
        businessPlanApprovalDate: ["B27"], // 사업계획승인일
        completionDate: ["G27"], // 준공일
        defectLiabilityExpirationDate1: ["P27"], // 하자보수보증종료일
        detailedSpecifications: ["V27"], // 상세제원
        safetyInspectionAndDiagnosisHistory: ["Z27"], // 안전점검진단이력
        repairAndReinforcementHistory: ["AG27"], // 보수보강이력
        accessibleVentCover: ["AN27"], // 통풍구방법
        designer: ["R29"], // 설계자
        contractor: ["AM29"], // 시공자
        totalConstructionCost: ["BA29"], // 총공사비
        seismicDesignTarget: ["E31"], // 지진설계대상
        seismicDesignApplication: ["R31"], // 지진설계적용
        seismicDesignStandard: ["AB31"], // 지진설계기준
        seismicPerformanceEvaluation: ["AM31"], // 지진성능평가
        seismicReinforcement: ["BA31"], // 지진보강
        young21Target: ["B33"], // 영21조대상
        auditor: ["R33"], // 감리자
        projectOwner: ["AB33"], // 사업주체
        constructionName: ["AM33"], // 공사명
        constructionSupervisor: ["BA33"], // 공사감독
        creationDate: ["B36"], // 작성일
        lastModifiedDate: ["AC36"], // 최종 수정일
        lastModifiedBy: ["AT36"], // 최종 수정자
        remarks: ["D37"], // 비고

        // 상세제원
        종류: ["F42"], // 종류
        허용월파량: ["M42"], // 허용월파량
        설계파_파고: ["S42"], // 설계파-파고
        설계파_파향: ["X42"], // 설계파-파향
        설계파_주기: ["AE42"], // 설계파-주기
        수심_최대: ["AL42"], // 수심-최대
        수심_최소: ["AQ42"], // 수심-최소
        조위_약최고고조위: ["AY42"], // 조위-약최고고조위
        조위_평균해면: ["BF42"], // 조위-평균해면

        DL_EL_표교차: ["B45"], // DL/EL-표교차
        DL_기준항만: ["F45"], // DL-기준항만
        형식분류_목적: ["M45"], // 형식분류-목적
        형식분류_구조: ["S45"], // 형식분류-구조
        마루높이: ["AE45"], // 마루높이
        사면경사: ["AL45"], // 사면경사
        주요구조물설계기준강도: ["AQ45"], // 주요구조물설계기준강도

        방파제파제제_연장_제간부: ["B49"], // 방파제파제제-연장-제간부
        방파제파제제_연장_제두부: ["J49"], // 방파제파제제-연장-제두부
        방파제파제제_상치공폭_제간부: ["R49"], // 방파제파제제-상치공폭-제간부
        방파제파제제_상치공폭_제두부: ["Y49"], // 방파제파제제-상치공폭-제두부
        호안_연장: ["AJ49"], // 호안-연장
        호안_상치공_규격: ["AS49"], // 호안-상치공-규격
        호안_상치공_형상: ["BC49"], // 호안-상치공-형상

        피복제_제간부: ["B52"], // 피복제-제간부
        피복제_제두부: ["J52"], // 피복제-제두부
        제체_블록식: ["R52"], // 제체-블록식
        제체_케이슨식: ["Y52"], // 제체-케이슨식
        제체_기타: ["AJ52"], // 제체-기타
        기초처리공: ["AS52"], // 기초처리공

        배후지_매립고: ["B55"], // 배후지-매립고
        배후지_이용조건: ["J55"], // 배후지-이용조건
        배후지_배수시설: ["R55"], // 배후지-배수시설
        간이접안시설_위치: ["U55"], // 간이접안시설-위치
        간이접안시설_대상선박규모: ["AA55"], // 간이접안시설-대상선박규모
        간이접안시설_방충재: ["AI55"], // 간이접안시설-방충재
        간이접안시설_계선주: ["AP55"], // 간이접안시설-계선주
        팡로표지시설_형식: ["AW55"], // 팡로표지시설-형식
        팡로표지시설_구조: ["BE55"], // 팡로표지시설-구조

        otherSpecifications: ["P56"], // 기타제원
      };

      for (const key in cellMatchInfo) {
        const cell = cellMatchInfo[key];
        for (const c of cell) {
          worksheet.getCell(c).value = this.form[key] ? this.form[key] : "";
        }
      }

      worksheet.getCell("Z25").value = "";
      worksheet.getCell("AD25").value = "";
      worksheet.getCell("AH25").value = "";
      worksheet.getCell("AL23").value = "";
      if (this.form.management_type === "중앙부처") {
        worksheet.getCell("Z25").value = "V";
      } else if (this.form.management_type === "지자체") {
        worksheet.getCell("AD25").value = "V";
      } else if (this.form.management_type === "(국가/지방)공기업") {
        worksheet.getCell("AH25").value = "V";
      } else if (this.form.management_type === "민간") {
        worksheet.getCell("AL23").value = "V";
      }

      worksheet.getCell("AU25").value = "";
      worksheet.getCell("BB25").value = "";
      worksheet.getCell("BD25").value = "";
      worksheet.getCell("BG23").value = "";
      if (this.form.ownerType === "중앙부처") {
        worksheet.getCell("AU25").value = "V";
      } else if (this.form.ownerType === "지자체") {
        worksheet.getCell("BB25").value = "V";
      } else if (this.form.ownerType === "(국가/지방)공기업") {
        worksheet.getCell("BD25").value = "V";
      } else if (this.form.ownerType === "민간") {
        worksheet.getCell("BG23").value = "V";
      }

      // 전화번호 (AK14)
      worksheet.getCell("AK14").value = `전화번호: ${this.form.phoneNumber}`;

      // 첨부자료 목록 (AV27)
      const fileNames = this.fileList.map((file) => file.originalName).join(", ");
      worksheet.getCell("AV27").value = fileNames;

      // 설계기간 (B29)
      worksheet.getCell("B29").value = `${this.form.designPeriod.sDate} ~ ${this.form.designPeriod.eDate}`;

      // 공시기간 (AB29)
      worksheet.getCell("AB29").value = `${this.form.constructionPeriod.sDate} ~ ${this.form.constructionPeriod.eDate}`;

      // 감리기간 (E33)
      worksheet.getCell("E33").value = `${this.form.auditPeriod.sDate} ~ ${this.form.auditPeriod.eDate}`;

      // 작성자 (N36)
      worksheet.getCell("N36").value = `${this.form.author}  (인)`;
    },
  },
};
</script>

<style scoped lang="scss">
table {
  width: 100%;
  border-collapse: collapse;
  table-layout: fixed;

  th,
  td {
    font-size: 14px;
    font-weight: 500;
    text-align: center;

    border: 1px solid #cdcdcd;
    padding: 5px;
  }

  th {
    background: #f9f9f9;
    padding: 10px 4px;
  }
}
</style>
<style scoped lang="scss">
.table-list {
  .action-button {
    margin-left: auto;
  }
}

.title {
  font-weight: 500;
  font-size: 16px;
  height: 17px;
  line-height: 17px;
  position: relative;
  padding-left: 12px;

  &::before {
    content: "";
    width: 8px;
    height: 8px;
    background: #7e72f2;
    display: block;
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    left: -8px;
    border-radius: 100%;
  }
}

.title-n {
  font-weight: 500;
  font-size: 16px;
  height: 17px;
  line-height: 17px;
}

.label-text {
  width: 114px;
  font-weight: 500;
  font-size: 14px;
}

.size-search {
  width: 200px;
}

.input-se {
  width: 100%;

  &::v-deep .start-end-title {
    width: 114px;
    font-weight: 500;
    font-size: 14px;
    justify-content: flex-start;
  }

  &::v-deep .mr-2 {
    flex: 1;
    margin-right: 10px !important;
  }

  &::v-deep .mr-2 + .mr-2 {
    margin-right: 0 !important;

    &::before {
      content: "~";
      margin-right: 10px;
    }
  }

  &::v-deep .inline-block {
    width: 100% !important;
  }
}

.vs-table-primary .is-selected {
  background: rgba(126, 114, 242, 0.6) !important;
  color: white;
}

.search-item {
  width: 100% !important;
  margin: 0 !important;

  &::v-deep > div:first-child {
    width: 114px !important;
    font-weight: 500;
    font-size: 14px;
  }

  &::v-deep > div:last-child {
    flex: 1 !important;

    .con-select {
      width: 100%;
    }
  }
}

.upload-img {
  width: 100%;
  height: 318px !important;
  margin-top: 22px;
}
</style>

<style lang="scss">
.none-card {
  box-shadow: none;
  border-radius: 0;
  display: inline-block;

  .vx-card__body {
    padding: 0 !important;
  }
}

span.up {
  color: #28c76f;
}

span.down {
  color: #ea5455;
}

.vs-table--tbody-table tr:nth-child(2n) {
  background-color: #f9f9f9;
}
</style>
